import React, { Component, Fragment } from 'react'
import {firebaseApp} from "../base";
import Form from './Form'

export default class Admin extends Component {


    logout(){
        firebaseApp.auth().signOut()
    }

    render() {
       const {uid, doctors, handleAdminChange, information, handleInformationChange} = this.props
        

    

        const cards = Object.keys(doctors).map(key => {
                if(doctors[key].uid === uid){
                    return(
                    <Form key={key} details={doctors[key]} handleAdminChange={handleAdminChange} information={information} handleInformationChange={handleInformationChange}/> 
                    )
                }
            })
                
            return (
                <Fragment>
                <header id="header">
                    <div className="container">
                        <div id="main-logo">
                            <a href='/'>
                                Centre Médical
                            <br/>
                                Bonnevoie
                            </a>
                        </div>
                    </div>
                </header>
                <header id="sub-header">
                    <div className="container">
                        <p className="schedule">
                           Modifications informations
                        </p>
                        
                    </div>
                </header>
                
                <main id="main">
                    <div id="ghost_banner"></div>
                    <div className="content">
                    
                    
                    <div className="form__edit" onSubmit={this.authenticate}>
                        {cards}      
                        

                        <button onClick={this.logout} className="button primary" type="submit" >Logout</button>
                    </div>

                               
                    </div>
                </main>
                </Fragment>
            )
        
        
    }
}
